var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white",
    fillOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    stroke: "#00306E",
    strokeOpacity: 0.08,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.2265 41.5956V50.9602C52.2265 53.3726 50.3323 55.956 48.0554 56.7158L41.9518 58.7293C40.8803 59.0902 39.1391 59.0902 38.0868 58.7293L31.9831 56.7158C29.6871 55.956 27.812 53.3726 27.812 50.9602L27.8311 41.5956L36.2882 47.0662C38.3546 48.4149 41.7604 48.4149 43.8268 47.0662L52.2265 41.5956Z",
    fill: "#3270FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2877 29.4766L43.8267 22.0115C41.7602 20.6628 38.3545 20.6628 36.288 22.0115L24.7696 29.4766C21.0768 31.851 21.0768 37.2267 24.7696 39.6201L27.831 41.5956L36.288 47.0663C38.3545 48.4149 41.7602 48.4149 43.8267 47.0663L52.2263 41.5956L54.8476 39.886V45.6986C54.8476 46.4774 55.4982 47.1232 56.2827 47.1232C57.0671 47.1232 57.7177 46.4774 57.7177 45.6986V36.3529C58.483 33.9025 57.6985 31.0532 55.2877 29.4766Z",
    fill: "#3270FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.a576d730a04123d6e57eaa00c55afba0.svg";
export { ForwardRef as ReactComponent };